import { render, staticRenderFns } from "./specialist.vue?vue&type=template&id=b3b4d70c&scoped=true&"
import script from "./specialist.vue?vue&type=script&lang=js&"
export * from "./specialist.vue?vue&type=script&lang=js&"
import style0 from "./specialist.vue?vue&type=style&index=0&id=b3b4d70c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b4d70c",
  null
  
)

export default component.exports